const planetCodeFullConversion = {
  0: "Sun",
  1: "Moon",
  2: "Mercury",
  3: "Venus",
  4: "Mars",
  5: "Jupiter",
  6: "Saturn",
  100: "Ascendent",
  101: "Rahu",
  102: "Ketu",
};

export default planetCodeFullConversion;
